











import Vue from 'vue';
import { recognition } from 'mycorems-app-accounts';
import { openModal } from 'mycorems-app-shared';
import AppSupportModal from './AppSupportModal.vue';

export default Vue.extend({
  computed: {
    isClient(): boolean {
      return recognition.isClient();
    },
  },
  methods: {
    open(): void {
      openModal(AppSupportModal, {
        unclosable: false,
      });
    },
  },
});
